export default __webpack_public_path__ + "assets/img/2wv8U0Z.jpg";